/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { StructureControlActionTypeEnum } from "./StructureControlActionTypeEnum";
import {
  StructureControlActionTypeEnumFromJSON,
  StructureControlActionTypeEnumFromJSONTyped,
  StructureControlActionTypeEnumToJSON,
  StructureControlActionTypeEnumToJSONTyped,
} from "./StructureControlActionTypeEnum";
import type { StructureTypeEnum } from "./StructureTypeEnum";
import {
  StructureTypeEnumFromJSON,
  StructureTypeEnumFromJSONTyped,
  StructureTypeEnumToJSON,
  StructureTypeEnumToJSONTyped,
} from "./StructureTypeEnum";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface PatchedTimedStructureControl
 */
export interface PatchedTimedStructureControl {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number;
  /**
   *
   */
  duration?: number;
  /**
   *
   */
  value?: Array<number>;
  /**
   *
   */
  type?: StructureControlActionTypeEnum;
  /**
   *
   */
  structureId?: number | null;
  /**
   *
   */
  structureType?: StructureTypeEnum;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
  /**
   *
   */
  gridId?: number | null;
  /**
   *
   */
  readonly uid?: string;
}

/**
 * Check if a given object implements the PatchedTimedStructureControl interface.
 */
export function instanceOfPatchedTimedStructureControl(
  value: object
): value is PatchedTimedStructureControl {
  return true;
}

export function PatchedTimedStructureControlFromJSON(json: any): PatchedTimedStructureControl {
  return PatchedTimedStructureControlFromJSONTyped(json, false);
}

export function PatchedTimedStructureControlFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedTimedStructureControl {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"] == null ? undefined : json["offset"],
    duration: json["duration"] == null ? undefined : json["duration"],
    value: json["value"] == null ? undefined : json["value"],
    type: json["type"] == null ? undefined : StructureControlActionTypeEnumFromJSON(json["type"]),
    structureId:
      json["structure_id"] === undefined
        ? undefined
        : json["structure_id"] === null
        ? null
        : json["structure_id"],
    structureType:
      json["structure_type"] == null
        ? undefined
        : StructureTypeEnumFromJSON(json["structure_type"]),
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
    gridId:
      json["grid_id"] === undefined ? undefined : json["grid_id"] === null ? null : json["grid_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
  };
}

export function PatchedTimedStructureControlToJSON(json: any): PatchedTimedStructureControl {
  return PatchedTimedStructureControlToJSONTyped(json, false);
}

export function PatchedTimedStructureControlToJSONTyped(
  value?: Omit<
    PatchedTimedStructureControl,
    "id" | "url" | "simulation" | "state" | "stateDetail" | "uid"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    value: value["value"],
    type: StructureControlActionTypeEnumToJSON(value["type"]),
    structure_id: value["structureId"],
    structure_type: StructureTypeEnumToJSON(value["structureType"]),
    grid_id: value["gridId"],
  };
}
